import generate from './tools/generate'

function input() {
    return {
        title: null,
        minute_limit: null,
        released_date: null,
        released_time: null,
        questionRandomized: false,
    }
}

function createtryout() {
    return {
        input: input(),
        questions: [],
    }
}

const getters = {
    released_at(state) {
        return `${state.input.released_date} ${state.input.released_time}`
    },

    formInput(state, getters) {
        return {
            title: state.input.title,
            minute_limit: state.input.minute_limit,
            released_at: getters.released_at,
            question_ids: state.questions.map(e => e.id),
            numbers: state.questions.map(e => e.number),
            question_randomized: state.input.questionRandomized
        }
    }
}

const actions = {
    appendQuestions({ state, commit }, questions) {
        var lastNumber

        if (state.questions.length > 0) {
            lastNumber = state.questions[state.questions.length - 1].number
        } else {
            lastNumber = 0
        }

        commit('SET_QUESTIONS', [
            ...state.questions,
            ...questions.map(e => {
                lastNumber++

                return {
                    ...e,
                    number: lastNumber
                }
            })
        ])
    }
}

export default {
    namespaced: true,
    state: createtryout(),
    getters,
    mutations: generate.mutations(createtryout()),
    actions,
}
